
import { Component, Watch } from "vue-property-decorator";
import { LinksModel } from "../models/LinksModel";
import BaseView from "./baseView";
import * as Contentful from "contentful";
import { ContentfulClientApi } from "contentful";
import AppStorage from "@/AppStorage";
import Vue from "vue";

@Component({
    components: {}
})
export default class Home extends BaseView {
    public links: LinksModel[] = [];
    public linksOriginal = "";
    public storage: AppStorage = Vue.AppStorage;
    selected: string[] = [];
    contentfulClient: ContentfulClientApi = Contentful.createClient({
        space: this.storage.contentfulSpace,
        accessToken: this.storage.contentfulAccessToken
    });

    linksCategory: string[] = ["Every day", "Developer", "IT"];

    @Watch("selected")
    onSelectedChanged(): void {
        window.localStorage.setItem("categories", JSON.stringify(this.selected));
        if (this.selected.length === 0) {
            this.links = JSON.parse(this.linksOriginal);
        } else {
            const links: LinksModel[] = JSON.parse(this.linksOriginal).filter((item: LinksModel) => {
                let isSelected = false;
                for (let i = 0; i <= item.category.length; i++) {
                    if (this.selected.includes(item.category[i])) {
                        isSelected = true;
                    }
                }
                return isSelected;
            });
            this.links = links;
        }
    }

    public mounted() {
        const sessionStorage: string | null = window.sessionStorage.getItem("links");
        if (sessionStorage) {
            this.linksOriginal = JSON.stringify(JSON.parse(sessionStorage));
            this.links = JSON.parse(sessionStorage);
            this.getCategories();
        } else {
            this.contentfulClient
                .getEntries({
                    // eslint-disable-next-line @typescript-eslint/camelcase
                    content_type: "link",
                    order: "fields.title"
                })
                .then(response => {
                    this.linksOriginal = JSON.stringify(this.parseLinks(response));
                    window.sessionStorage.setItem("links", this.linksOriginal);
                    this.links = this.parseLinks(response);
                    this.getCategories();
                });
        }
    }

    getCategories(): void {
        const localStorage: string | null = window.localStorage.getItem("categories");
        if (localStorage) {
            this.selected = JSON.parse(localStorage);
        }
    }

    parseLinks(response: any): LinksModel[] {
        const links: LinksModel[] = [];
        response.items.forEach((item: any) => {
            links.push({
                id: item.sys.id,
                url: item.fields.url,
                imageSrc: item.fields.image.fields.file.url,
                title: item.fields.title,
                newWindow: item.fields.newWindow,
                displayTitle: item.fields.displayTitle,
                category: item.fields.category
            });
        });

        return links;
    }

    public openLink(url: string, newWindow: boolean) {
        if (newWindow) {
            window.open(url);
        } else {
            this.$router.push(url);
        }
    }
}
